import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdaptiveImageDirective } from './directives/adaptive-image.directive';
import { ConnectionService } from './services/connection-service';
import { AdaptiveImageService } from './services/adaptive-image.service';
import { NetworkAwarePreloadStrategy } from './preload/network-aware-preload-strategy';

@NgModule({
  declarations: [
    AdaptiveImageDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [
    AdaptiveImageDirective
  ],
  providers: [
    ConnectionService,
    AdaptiveImageService,
    NetworkAwarePreloadStrategy
  ]
})
export class OptimizationModule { }
